<template>
  <v-col class="pa-8">
    <!-- Search Bar -->
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search"
          label="Search doctors..."
          class="input ma-0 pa-0"
          prepend-inner-icon="mdi-magnify"
          rounded
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Doctors Table -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredDoctors"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Doctors List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="#4390c0"
              ></v-progress-circular>
            </v-toolbar>
          </template>

          <!-- Status Chip -->
          <template v-slot:item.status="{ item }">
            <v-chip color="#4390c0" dark small label>
              {{ item.status || "pending" }}
            </v-chip>
          </template>

          <!-- Eye Icon Action -->
          <template v-slot:item.action="{ item }">
            <v-icon
              color="#4390c0"
              class="cursor-pointer"
              @click="goToManageSubscriptions(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Loading Overlay -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="80" color="#4390c0" />
    </v-overlay>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  getFirestore,
  query,
  updateDoc,
  Timestamp,
  onSnapshot,
  doc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  name: "DoctorsTable",
  data() {
    return {
      headers: [
        { text: "Full Name", value: "fullName" },
        { text: "Email", value: "email" },
        { text: "Specialization", value: "specialization" },
        { text: "Phone", value: "CellNo" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action", sortable: false },
      ],
      doctors: [],
      search: "",
      loading: false,
      unsubscribeDoctors: null,
    };
  },
  computed: {
    filteredDoctors() {
      if (!this.search) return this.doctors;
      return this.doctors.filter((doc) =>
        Object.values(doc).some((val) =>
          String(val).toLowerCase().includes(this.search.toLowerCase())
        )
      );
    },
  },
  methods: {
    fetchDoctors() {
      try {
        this.loading = true;
        const q = query(collection(db, "doctors"));

        // Real-time Firestore listener
        this.unsubscribeDoctors = onSnapshot(q, (snapshot) => {
          this.doctors = snapshot.docs.map((doc) => {
            const data = doc.data();
            data.id = doc.id;

            // Full name
            data.fullName = `${data.name} ${data.surname}`;

            // Specialization fallback
            data.specialization = data.profession
              ? data.profession[0]
              : "Not specified";

            return data;
          });

          this.loading = false;
        });
      } catch (error) {
        console.error("Error fetching doctors:", error);
        this.loading = false;
      }
    },
    goToManageSubscriptions(item) {
      // You can also pass the doctor ID as a route param if needed
      this.$router.push({
        path: "/manageSubscriptions",
        query: { doctorId: item.id },
      });
    },
  },
  async created() {
    await this.fetchDoctors();
  },
  beforeUnmount() {
    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }
  },
};
</script>

<style scoped>
.v-data-table {
  background-color: #fff;
  border-radius: 12px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
